import { legacySection } from '../content/site';
import { pillarIcons } from './Icons';
import { Reveal } from './Reveal';
import './Legacy.css';

export function Legacy() {
  return (
    <section className="section section--cream" id="legacy">
      <div className="container">
        <Reveal>
          <div className="section-head">
            <p className="eyebrow">{legacySection.eyebrow}</p>
            <h2 className="section-title">{legacySection.title}</h2>
            <p className="section-lead">{legacySection.lead}</p>
          </div>
        </Reveal>

        <ul className="legacy__grid">
          {legacySection.pillars.map((pillar, index) => {
            const Icon = pillarIcons[pillar.icon];
            return (
              <li key={pillar.title}>
                <Reveal delay={index * 70} className="legacy__reveal">
                  <article className="pillar">
                    <span className="pillar__icon">
                      <Icon width={22} height={22} />
                    </span>
                    <h3 className="pillar__title">{pillar.title}</h3>
                    <p className="pillar__body">{pillar.body}</p>
                  </article>
                </Reveal>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
